/* eslint-disable camelcase -- FIXME: automatically added for existing issue */
import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getFeatureFlag = ({ flagId: flag_id }) =>
  call(websocketFetch, 'get_feature_flag', { flag_id });
